const translations = {
  'allCourses.seo.title': 'Los Mejores Cursos TEFL en España por TEFL Iberia',
  'allCourses.seo.description':
    'TEFL Iberia ofrece una amplia gama de cursos TEFL intensivos en España, para adaptarse a todos los presupuestos, horarios y necesidades. Saber más.',
};

export default translations;
